import types from "dictionaries/ReqTypes";

export default {
  [types.initial]: "Initial",
  [types.eco]: "ECO",
  [types.variant]: "Variant",
  [types.ota]: "OTA",
  [types.renewal]: "Renewal/Update"
};
